import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgProfileIcon = function SvgProfileIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#828282",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.756 27.401c-6.3 0-11.409-5.238-11.409-11.7S17.455 4 23.756 4c6.3 0 11.409 5.239 11.409 11.7 0 6.463-5.108 11.701-11.409 11.701m0-2.799c4.793 0 8.68-3.985 8.68-8.901s-3.887-8.902-8.68-8.902c-4.794 0-8.68 3.986-8.68 8.902s3.886 8.901 8.68 8.901m6.835 5.61.577-.3.592.269c5.61 2.549 9.322 6.46 10.772 11.932L43 43.879H5.024l.454-1.758c1.414-5.473 5.12-9.39 10.748-11.94l.591-.269.577.3a14.29 14.29 0 0 0 13.197 0m-13.829 2.794c-3.956 1.916-6.67 4.562-8.072 8.074h30.62c-1.424-3.514-4.142-6.16-8.088-8.074a16.95 16.95 0 0 1-14.46 0"
  })));
};

export { SvgProfileIcon as default };
